import {Component} from '@angular/core';
import {DisplayServiceProvider} from '../../../core/services/display-service/display-service';
import {ENVIRONMENT} from '../../../../../environments/environment';
import {IonicPage, NavParams} from 'ionic-angular';
import {StorageServiceProvider} from '../../../core/services/storage-service/storage-service';
import {TextServiceProvider} from '../../../core/services/text-service/text-service';
import {UserTaskService} from "../../services/user-task.service/user-task.service";
import {GenericDataViewService} from "../../../../generic-data-view/generic-data-view.service";
import {UserTaskTemplateListPage} from "./user-task-template-list/user-task-template-list";
import {
  UserTaskConfig,
  UserTaskTabConfig
} from "../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/interfaces/user-task-config.interface";

@IonicPage()
@Component({
  selector: 'page-user-task-list',
  templateUrl: 'user-task-list.html',
})
export class UserTaskListPage {
  public db: any;
  public engineUrl = ENVIRONMENT.engineUrl;
  public newLoading: boolean = true;
  public assignedLoading: boolean = true;
  public closedLoading: boolean = true;
  public taskListTemplatePage = UserTaskTemplateListPage;
  public selectedParent;
  private selectedTabType: string;
  private config: UserTaskConfig;
  private tabs: UserTaskTabConfig[];
  private selectedTabId = 0;

  constructor(
    private genericDataViewService: GenericDataViewService,
    private displayService: DisplayServiceProvider,
    private storageService: StorageServiceProvider,
    public textService: TextServiceProvider,
    private navParams: NavParams,
    private userTaskService: UserTaskService,
  ) {
  }

  ngOnInit() {
    const data = this.navParams.data;
    this.config = this.genericDataViewService.getConfig(data.viewId);
    this.tabs = this.config.tabs.filter(
                (tab: UserTaskTabConfig) => !!tab.visible
    );
    if (this.tabs.length === 0) {
      console.warn('No tabs defined for ${data.viewId} configuration');
    }
    this.db = this.storageService.db;
    this.selectedParent = this.navParams.data.element || {};
    this.selectedTabType = this.tabs.find((value, index) => index === this.selectedTabId).name;
    let selectedTabName = data.selectedTab;
    if (selectedTabName) {
        this.selectedTabId = this.tabs.map(t => t.name).indexOf(selectedTabName);
    }
  }

  ionViewDidEnter(): void {
    this.userTaskService.reloadUserTaskListEventEmitter.next(this.selectedTabType);
  }

  private hideHeader() {
    return !(this.navParams.data.element != undefined && this.navParams.data.element.id != undefined);
  }

  onTabChanged(event: any) {
    if (this.selectedTabType !== event.id) {
      this.userTaskService.reloadUserTaskListEventEmitter.next(event.id);
      this.selectedTabType = event.id;
    }
  }

}





// WEBPACK FOOTER //
// ./src/modules/user-tasks/pages/user-task-list/user-task-list.ts